var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconInfoCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.184 3.50977C8.914 3.50977 3 9.42377 3 16.6938C3 23.9638 8.914 29.8768 16.184 29.8768C23.454 29.8768 29.367 23.9638 29.367 16.6938C29.367 9.42377 23.453 3.50977 16.184 3.50977ZM16.184 27.5108C10.22 27.5108 5.368 22.6578 5.368 16.6938C5.368 10.7298 10.22 5.87777 16.184 5.87777C22.149 5.87777 27.001 10.7298 27.001 16.6938C27.001 22.6578 22.148 27.5108 16.184 27.5108Z",
    fill: "#565656"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0004 23.2417L17.0664 23.2417L17.0664 14.5087L15.0004 14.5087L15.0004 23.2417Z",
    fill: "#565656"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0004 12.5747L17.0664 12.5747L17.0664 10.5097L15.0004 10.5097L15.0004 12.5747Z",
    fill: "#565656"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfoCircle);
export default __webpack_public_path__ + "static/media/icon-info-circle.87082c137f59fe79d77ea0ce15b23134.svg";
export { ForwardRef as ReactComponent };